module.exports = __webpack_public_path__ + "static/media/Babel-1-Right_2.95bb6678.webp";